export default __webpack_public_path__ + "static/media/cholesterol.8fa81445.jpeg";